
import parsePhoneNumber from "libphonenumber-js/max";

export default {
  name: "CShowPhone",

  props: {
    phone: {
      type: String,
      required: true,
    },
    profileId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      isHidden: true,
      dots: new Array(6).fill(null),
      sendStatShowNumber: true,
    };
  },

  computed: {
    maskedPhone() {
      const phone = parsePhoneNumber(this.phone);

      if (phone?.formatInternational()) {
        return phone.formatInternational().slice(0, -9);
      } else {
        return this.$t("not-have-phone");
      }
    },

    formattedPhone() {
      const phone = parsePhoneNumber(this.phone);

      if (phone?.formatInternational()) {
        return phone.formatInternational();
      } else {
        return this.$t("not-have-phone");
      }
    },
  },

  methods: {
    async toggleVisibility() {
      if (this.sendStatShowNumber) {
        this.$axios.post("/api/models/show-phone", {
          id: this.profileId,
        });
        this.sendStatShowNumber = false;
      }
      this.isHidden = !this.isHidden;
      this.$emit("visibility-changed", !this.isHidden);
    },

    getContainer() {
      return this.$refs.phoneContainer;
    },
  },
};
